import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import placeholderImageSrc from '../../assets/images/placeholder-1x1.gif';
import styles from './ProgressiveImage.css';

const cx = classnames.bind(styles);

function ProgressiveImage({
    src,
    className,
    ...props
}) {
    const [imageSrc, setImageSrc] = useState(placeholderImageSrc);
    const classes = cx({
        image: true,
        [className]: className,
        loaded: imageSrc === src
    });

    useEffect(() => {
        const img = new Image();

        img.src = src;
        img.onload = () => {
            setImageSrc(src);
        };
    }, [src]);

    return (
        <img
            src={imageSrc}
            className={classes}
            {...props}
        />
    );
}

ProgressiveImage.propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string
}

ProgressiveImage.defaultProps = {
    className: ''
}

export {
    ProgressiveImage
}
